import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { transformBlankToNull } from "../../../services/Util";
import {
  getAxiosResponse,
  putAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import DataTable, { createTheme } from "react-data-table-component";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Constants from "../../../Constants";
import $ from "jquery";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
export default function EditIntendendUse() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  const [intendedUseTasks, setIntendedUseTasks] = useState([]);
  const [enableCount, setEnableCount] = useState(0);
  const [intendedUse, setIntendedUse] = useState({});
  const [pending, setPending] = useState(true);

  const closeRef = useRef();
  const backRef = useRef();
  const param = useParams();
  const intendedUseId = param.id;
  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']").attr({
      "aria-label": column.name,
      "aria-sort":
        sortDirection.toUpperCase() === Constants.DESC
          ? Constants.DESCENDING
          : Constants.ASCENDING,
    });
  };
  const selectTask = (e,row) =>{
    var countEnabled = 0
    var copyTasks = intendedUseTasks
    copyTasks.map((selected,index)=>{
        if(selected.type === row.type){
            selected.enabled = e.target.checked
        }
    })
    copyTasks.map((data) => {
        if (data.enabled) {
          countEnabled = countEnabled + 1;
        }
      });
      setEnableCount(countEnabled)  
    setIntendedUseTasks(copyTasks)
    if(enableCount===5 ){
      $(e.target).attr('aria-describedby', 'max-length-error');
    }
  }
  const columns = [
    {
      id: "intendedUseTasks.enabled",
      name: "Enabled",
      maxWidth: "150px",
      selector: (row) => row.enabled,
      sortable: false,
      cell: (row) => (
        <div className="file-actions flex-center" >
          <div
            className="form-check small-checkbox ml-12 mb-0"
            style={{ padding: "0 5px 0 5px" }}
          >
            <input
              className="form-check-input"
              type="checkbox"
              name={row.type}
              id={row.type}
              onChange={(e) => selectTask(e,row)}
              checked={row.enabled}
              disabled={
                row.type === "TRANSLATION" ||
                (enableCount === 5 && row.enabled === false)
              }
            />
            <label className="form-check-label" htmlFor={row.type}></label>
          </div>
        </div>
      ),
    },
    {
      id: "intendedUseTasks.fullName",
      name: "Work Item",
      maxWidth: "350px",
      selector: (row) => row.fullName,
      sortable: true,
      cell: (row) => (
        <div className="file-actions flex-center" >
          {row.fullName}
        </div>
      ),
    },
    {
      id: "intendedUseTasks.description",
      name: "Description",
      wrap: true,
      sortable: true,
      selector: (row) => row.description,
      cell: (row) => (
        <div className="file-actions flex-center">
          {row.description}
        </div>
      ),
    },
  ];

  useEffect(() => {
    var countEnabled = 0;
    setPending(true);
    getAxiosResponse(APIUrls.UPDATE_CREATE_INTENDED_USE(intendedUseId)).then(
      (res) => {
        if (res.data !== "") {
          setPending(false);
          setIntendedUse(res.data.data);
        }
      }
    );
    getAxiosResponse(APIUrls.INTENDED_USE_TASKS(intendedUseId)).then((res) => {
      if (res.data !== "") {
        setPending(false);
        setIntendedUseTasks(res.data.data);
        res.data.data.map((data) => {
          if (data.enabled) {
            countEnabled = countEnabled + 1;
          }
        });
      }
      setEnableCount(countEnabled);
    });

    backRef.current.focus()
  }, []);

  $(document).on(
    "click",
    ".datatable-block .rdt_TableCell button.inline-flex, .border-right .blue-btn",
    function () {
      $(this).addClass("focusAdd");
    }
  );
  
  $(".rdt_Table").attr("aria-label", "Work items for intended use");
  $(document).ready(function () {
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden", "true");
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex", "-1");
  });
  const saveWorkItem = () =>{
    var defaultPayload = []
    var enabledPayload = []
    //var finalPayload = {}
    intendedUseTasks.map((task,index)=>{
        var defaultObject = {
            "enabled" : '',
            "path": null,
            "applicationVersion": null,
            "id": null,
            "projectTaskType": {
                "type": "",
                "parentType": null,
                "description": "",
                "fullName": "",
                "shortName": ""
            }
        }
            defaultObject.projectTaskType.type = task.type
            defaultObject.projectTaskType.description =task.description
            defaultObject.projectTaskType.fullName = task.fullName
            defaultObject.projectTaskType.shortName = task.shortName
            if(task.enabled === true){
                defaultObject.enabled = true
            }else{
                defaultObject.enabled = false
            }
            defaultPayload.push(defaultObject)
    })
    defaultPayload.id = Number(intendedUseId)
    
    enabledPayload = defaultPayload.filter((task)=>{
            return task.enabled === true
    })
    if(enabledPayload.length > 0){
        enabledPayload.map((payload)=>{
            payload.projectTaskType.display = payload.projectTaskType.fullName
            payload.projectTaskType.type = payload.projectTaskType.type.toLowerCase()
            delete payload.projectTaskType.description
            delete payload.projectTaskType.fullName
            delete payload.projectTaskType.shortName
        })
    }
    defaultPayload.tasks = enabledPayload
    
   var finalPayload = {...defaultPayload}
    var payload = transformBlankToNull(finalPayload)
    putAxiosResponse(APIUrls.INTENDED_USE_TASKS(intendedUseId),payload).then(
        (res) => {
          if (res.data !== "") {
            navigate("/settings/project-setting-intendend")
          }
        }
      );
  }
  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Intended use', url:'settings/project-setting-intendend'},
    {label:'Edit Intended use', url:''},
   ];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
            <div className="project-setting-page">
              <div className="project-heading userprofile-heading">
                <div className="back-arrow flex-center">
                  <button ref={backRef} aria-label="back" onClick={() => navigate("/settings/project-setting-intendend")} >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none" >
                      <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                        fill="#1D4ED8" />
                    </svg>
                  </button>
                  <span>Return to Intended Use Settings</span>
                </div>
                <h3 className="flex">Work items for intended use : {intendedUse.name}</h3>
                <span>
                  Work items that vendors will be asked to include in their bid
                  for your projects under this intended use.
                </span>
              </div>
              <div className="white-bg">
                <div className="flex flex-center">
                  <div className="flex two-col border-right">
                    {enableCount === 5 ? (
                      <p className="error defaultFontsize mar-bot15" role="alert" id="max-length-error">
                        You have reached the maximum of 5 work items for this intended use.
                      </p>
                    ) : (
                      <p>
                        You can select up to {5 - enableCount} more work item(s) for this intended use.
                      </p>
                    )}
                  </div>
                </div>

                <div className="datatable-block">
                  <DataTable
                    keyField="id"
                    columns={columns}
                    data={intendedUseTasks}
                    //defaultSortFieldId={1}
                    responsive
                    striped
                    progressPending={pending}
                    pointerOnHover={true}
                    //paginationTotalRows={intendendUse.length}
                    onSort={handleSort}
                    //defaultSortFieldId="intendendUse.name"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
          <div>
            <button className="btn-default"  
            onClick={() => navigate("/settings/project-setting-intendend")}>Cancel</button>
          </div>
          <div>
            <button className="btn-default" onClick={saveWorkItem}>Save</button>
          </div>
        </div>
      </div>
    </div>
  );
}
